export default "__VITE_ASSET__B_3Wd0Dc__"